import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, useMediaQuery } from '@mui/material';
import { useEffect, useState } from "react";
import { Select as SelectAnt, Tooltip } from "antd";
import CircularProgress from "@mui/material/CircularProgress";
import { AES, enc } from "crypto-js";
import * as url from "store/constant/Endpoints";
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Stack,
  OutlinedInput,
  Button,
} from "@mui/material";
import IconButton from 'components/@extended/IconButton';
import { DRAWER_WIDTH } from 'config';
import { HambergerMenu } from 'iconsax-react';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, handleDrawerToggle }) => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  // header content         
  const headerContent = useMemo(() => <HeaderContent open={open} />, [open]);
  const [restore_com, set_Restore_Cmp] = useState();
  const [showfielddta, set_Show_Data] = useState();
  const iconBackColorOpen = 'secondary.200';
  const iconBackColor = 'secondary.100';
  const sicpaMain = "#00529D";

  useEffect(() => {
    set_Restore_Cmp(localStorage.getItem("teams_id"));
  }, [localStorage.getItem("teams_id")]);

  let permissionUser = localStorage.getItem("data");

  let decryptedData = null;
  if (permissionUser) {
    try {
      decryptedData = AES.decrypt(
        permissionUser,
        url.encryptionSecret
      ).toString(enc.Utf8);
    } catch (error) {
      localStorage.clear();
      window.location.reload();
    }
  }

  const permissionsAssrray =
    decryptedData && JSON.parse(decryptedData);

  useEffect(() => {
    if (Array.isArray(permissionsAssrray?.teams) && permissionsAssrray?.teams.length !== 0) {
      let FilterData = permissionsAssrray?.teams?.filter((item) => item.id == restore_com);
      set_Show_Data(FilterData[0]?.name);
    }
  }, [restore_com, permissionsAssrray?.teams]);

  const HanldeChangeTeams = (value) => {
    localStorage.setItem("teams_id", value);
    set_Restore_Cmp((prev) => !prev);
    window.location.reload();
  };

  const dropdownteamsoptions =
    Array.isArray(permissionsAssrray?.teams) && permissionsAssrray?.teams?.length !== 0
      ? permissionsAssrray?.teams?.map((v) => ({ value: v.id, label: v.name }))
      : [];


  // common header
  const mainHeader = (
    <Toolbar sx={{ px: { xs: 2, sm: 4.5, lg: 8, bgcolor: "#ffff", boxShadow: " rgba(17, 17, 26, 0.1) 0px 1px 0px;" } }}>
      <IconButton
        aria-label="open drawer"
        onClick={handleDrawerToggle}
        edge="start"
        color="secondary"
        variant="light"
        size="large"
        sx={{ color: 'sicpa.main', ml: { xs: 0, lg: -2 }, p: 1 }}
      >
        <HambergerMenu />
      </IconButton>
      {permissionsAssrray?.role_name !== "super_admin" ? <div style={{ marginLeft: "10px" }}>
        <Stack>
          <FormControl variant="outlined" fullWidth>
            {showfielddta ? (
              <SelectAnt
                showSearch
                style={{
                  width: "200px",
                  height: "40px",
                }}
                value={showfielddta ?? ""}
                onChange={HanldeChangeTeams}
                tokenSeparators={[","]}
                options={dropdownteamsoptions}
                placeholder="Select Currency"
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            ) : (
              <CircularProgress size={30} />
            )}
          </FormControl>
        </Stack>
      </div> : null}
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    elevation: 0,
    sx: {
      bgcolor: "#0055A2",
      backdropFilter: 'blur(8px)',
      zIndex: 1200,
      width: open ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%'
    }

  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

Header.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func
};



export default Header
